// extracted by mini-css-extract-plugin
export var grid = "_v-0";
export var span1 = "_v-2";
export var span10 = "_v-b";
export var span10L = "_v-z";
export var span10M = "_v-n";
export var span10Xl = "_v-1b";
export var span11 = "_v-c";
export var span11L = "_v-10";
export var span11M = "_v-o";
export var span11Xl = "_v-1c";
export var span12 = "_v-d";
export var span12L = "_v-11";
export var span12M = "_v-p";
export var span12Xl = "_v-1d";
export var span1L = "_v-q";
export var span1M = "_v-e";
export var span1Xl = "_v-12";
export var span2 = "_v-3";
export var span2L = "_v-r";
export var span2M = "_v-f";
export var span2Xl = "_v-13";
export var span3 = "_v-4";
export var span3L = "_v-s";
export var span3M = "_v-g";
export var span3Xl = "_v-14";
export var span4 = "_v-5";
export var span4L = "_v-t";
export var span4M = "_v-h";
export var span4Xl = "_v-15";
export var span5 = "_v-6";
export var span5L = "_v-u";
export var span5M = "_v-i";
export var span5Xl = "_v-16";
export var span6 = "_v-7";
export var span6L = "_v-v";
export var span6M = "_v-j";
export var span6Xl = "_v-17";
export var span7 = "_v-8";
export var span7L = "_v-w";
export var span7M = "_v-k";
export var span7Xl = "_v-18";
export var span8 = "_v-9";
export var span8L = "_v-x";
export var span8M = "_v-l";
export var span8Xl = "_v-19";
export var span9 = "_v-a";
export var span9L = "_v-y";
export var span9M = "_v-m";
export var span9Xl = "_v-1a";
export var stretch = "_v-1";